export default __webpack_public_path__ + "static/media/office1-after2-1024w.fd2f6c1c.png";